import React, { useState, ReactNode } from 'react';

import { RequestAccessFormContext } from './request-access-form-context';
import { RequestAccessFormState } from './types';

type CurrentStepState = Pick<RequestAccessFormState, 'step'>['step'];
type SelectedAccountIdsState = Pick<RequestAccessFormState, 'selectedAccounts'>['selectedAccounts'];
type SelectedLocationIdsState = Pick<
    RequestAccessFormState,
    'selectedLocations'
>['selectedLocations'];
type DirectoryUserAccountIdState = Pick<
    RequestAccessFormState,
    'directoryUserAccountId'
>['directoryUserAccountId'];
type DirectoryUserAccountSecret = Pick<
    RequestAccessFormState,
    'directoryUserAccountSecret'
>['directoryUserAccountSecret'];
type UserEmailState = Pick<RequestAccessFormState, 'userEmail'>['userEmail'];

const RequestAccessFormProvider = ({
    children,
    currentStep = 0,
}: {
    children: ReactNode;
    currentStep?: CurrentStepState;
}) => {
    const [step, setStep] = useState<CurrentStepState>(currentStep);
    const [selectedAccounts, setSelectedAccounts] = useState<SelectedAccountIdsState>([]);
    const [selectedLocations, setSelectedLocations] = useState<SelectedLocationIdsState>([]);
    const [directoryUserAccountId, setDirectoryUserAccountId] =
        useState<DirectoryUserAccountIdState>(undefined);
    const [directoryUserAccountSecret, setDirectoryUserAccountSecret] =
        useState<DirectoryUserAccountSecret>('');
    const [userEmail, setUserEmail] = useState<UserEmailState>('');

    const value = {
        step,
        selectedAccounts,
        selectedLocations,
        directoryUserAccountId,
        directoryUserAccountSecret,
        userEmail,
        setStep,
        setSelectedAccounts,
        setSelectedLocations,
        setDirectoryUserAccountId,
        setDirectoryUserAccountSecret,
        setUserEmail,
    };

    return (
        <RequestAccessFormContext.Provider value={value}>
            {children}
        </RequestAccessFormContext.Provider>
    );
};

export { RequestAccessFormProvider };
